// For /user-panel/orders/sales
// For /user-panel/orders/orders
export default [
    // code for old Start fulfillment flow {
    //    key: 'checkboxes',
    //    label: '',
    //    variant: 'column-xs align-text-top'
    // },
    {
        key: 'actions',
        label: '',
        variant: 'align-text-top',
    },
    {
        key: 'uniqueNumber',
        label: 'Boxiti',
        variant: 'align-text-top',
        sortable: true
    },
    {
        key: 'createdAt',
        label: 'Date',
        variant: 'align-text-top',
        sortable: true
    },
    // {
    //     key: 'externalId',
    //     label: 'Marketplace ID',
    //     sortable: true
    // },
    {
        key: 'service',
        label: 'Sales channel',
        variant: ' align-text-top',
    },
    {
        key: 'buyer',
        label: 'Buyer',
        variant: 'align-text-top',
        sortable: true
    },
    {
        key: 'country',
        label: 'Country of delivery',
        variant: 'align-text-top',
        sortable: true
    },
    {
        key: 'productsImg',
        label: 'Images ',
        variant: 'column-img p-0'
    },
    {
        key: 'name',
        label: 'Name',
        variant: 'p-none'
    },
    {
        key: 'productsEdit',
        label: '',
        variant: 'column-md p-0'
    },
    {
        key: 'sku',
        label: 'SKU',
        variant: 'p-none'
    },
    {
        key: 'fnsku',
        label: 'FNSKU',
        variant: 'p-none'
    },
    {
        key: 'productQuantity',
        label: 'Quantity',
        variant: 'p-none'
    },
    // {
    //     key: 'orderedQuantity',
    //     label: 'Quantity'
    // },
    // {
    //     key: 'orderedQuantity',
    //     label: 'Number of Units'
    // },
    {
        key: 'total',
        label: 'Total',
        sortable: true,
        variant: 'p-none'
    },
    {
        key: 'salesCurrencyCode',
        label: 'Currency',
        // sortable: true,
        variant: 'column-md p-0'
    },
    // {
    //     key: 'orderParcels',
    //     label: 'Parcels',
    // },
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/ordersSales.js